// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_org_type.ml",
      103,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "OrgType"
                    ]]
                },
                "V1"
              ]]
          },
          "Common"
        ]]
    });

const Common = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_org_type.ml",
      177,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "OrgType"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_org_type.ml",
      249,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "OrgType"
        ]]
    });

const OrgType = Caml_module.init_mod([
      "proto/commonapis/gen/buhta_common_v1_org_type.ml",
      319,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.common.v1.OrgType";
}

function to_int(param) {
  switch (param) {
    case /* ORG_TYPE_UNSPECIFIED */0 :
        return 0;
    case /* ORG_TYPE_IP */1 :
        return 1;
    case /* ORG_TYPE_TOO */2 :
        return 10;
    case /* ORG_TYPE_TDO */3 :
        return 11;
    case /* ORG_TYPE_PK */4 :
        return 12;
    case /* ORG_TYPE_AO */5 :
        return 30;
    case /* ORG_TYPE_OAO */6 :
        return 31;
    case /* ORG_TYPE_ZAO */7 :
        return 32;
    case /* ORG_TYPE_OO */8 :
        return 50;
    case /* ORG_TYPE_GP */9 :
        return 60;
    case /* ORG_TYPE_PERSON */10 :
        return 300;
    case /* ORG_TYPE_OTHER */11 :
        return 400;
    
  }
}

function from_int_exn(n) {
  if (n >= 51) {
    if (n !== 60) {
      if (n !== 300) {
        if (n !== 400) {
          return Ocaml_protoc_plugin__Result.raise({
                      NAME: "Unknown_enum_value",
                      VAL: n
                    });
        } else {
          return /* ORG_TYPE_OTHER */11;
        }
      } else {
        return /* ORG_TYPE_PERSON */10;
      }
    } else {
      return /* ORG_TYPE_GP */9;
    }
  }
  if (n >= 30) {
    if (n >= 33) {
      if (n >= 50) {
        return /* ORG_TYPE_OO */8;
      } else {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      }
    } else {
      return n - 25 | 0;
    }
  }
  switch (n) {
    case 0 :
        return /* ORG_TYPE_UNSPECIFIED */0;
    case 1 :
        return /* ORG_TYPE_IP */1;
    case 2 :
    case 3 :
    case 4 :
    case 5 :
    case 6 :
    case 7 :
    case 8 :
    case 9 :
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
    case 10 :
        return /* ORG_TYPE_TOO */2;
    case 11 :
        return /* ORG_TYPE_TDO */3;
    case 12 :
        return /* ORG_TYPE_PK */4;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* ORG_TYPE_UNSPECIFIED */0 :
        return "ORG_TYPE_UNSPECIFIED";
    case /* ORG_TYPE_IP */1 :
        return "ORG_TYPE_IP";
    case /* ORG_TYPE_TOO */2 :
        return "ORG_TYPE_TOO";
    case /* ORG_TYPE_TDO */3 :
        return "ORG_TYPE_TDO";
    case /* ORG_TYPE_PK */4 :
        return "ORG_TYPE_PK";
    case /* ORG_TYPE_AO */5 :
        return "ORG_TYPE_AO";
    case /* ORG_TYPE_OAO */6 :
        return "ORG_TYPE_OAO";
    case /* ORG_TYPE_ZAO */7 :
        return "ORG_TYPE_ZAO";
    case /* ORG_TYPE_OO */8 :
        return "ORG_TYPE_OO";
    case /* ORG_TYPE_GP */9 :
        return "ORG_TYPE_GP";
    case /* ORG_TYPE_PERSON */10 :
        return "ORG_TYPE_PERSON";
    case /* ORG_TYPE_OTHER */11 :
        return "ORG_TYPE_OTHER";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "ORG_TYPE_AO" :
        return /* ORG_TYPE_AO */5;
    case "ORG_TYPE_GP" :
        return /* ORG_TYPE_GP */9;
    case "ORG_TYPE_IP" :
        return /* ORG_TYPE_IP */1;
    case "ORG_TYPE_OAO" :
        return /* ORG_TYPE_OAO */6;
    case "ORG_TYPE_OO" :
        return /* ORG_TYPE_OO */8;
    case "ORG_TYPE_OTHER" :
        return /* ORG_TYPE_OTHER */11;
    case "ORG_TYPE_PERSON" :
        return /* ORG_TYPE_PERSON */10;
    case "ORG_TYPE_PK" :
        return /* ORG_TYPE_PK */4;
    case "ORG_TYPE_TDO" :
        return /* ORG_TYPE_TDO */3;
    case "ORG_TYPE_TOO" :
        return /* ORG_TYPE_TOO */2;
    case "ORG_TYPE_UNSPECIFIED" :
        return /* ORG_TYPE_UNSPECIFIED */0;
    case "ORG_TYPE_ZAO" :
        return /* ORG_TYPE_ZAO */7;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, OrgType, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "OrgType"
        ]]
    }, V1, {
      OrgType: OrgType
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "OrgType"
              ]]
          },
          "V1"
        ]]
    }, Common, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "OrgType"
                    ]]
                },
                "V1"
              ]]
          },
          "Common"
        ]]
    }, Buhta, {
      Common: Common
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
